module.exports = __webpack_public_path__ + "static/slide1-743x573-2c2c9d7bdfe8d5a9146d7262908172d3.gif";